import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "gsl-hrm-paper-container" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          class: _normalizeClass(['tab-btn', {active: _ctx.activeTab === index}, 'tab-title']),
          onClick: ($event: any) => (_ctx.activeTab = index)
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, _ctx.tabs[_ctx.activeTab]?.name, {}, undefined, true)
    ])
  ]))
}